import { createDeepEqualSelector } from '../../utils/selectors';

import { selectAuth } from '../selectors';

export const selectPasswordReset = createDeepEqualSelector(selectAuth, (auth) => auth.passwordReset);
